import React, { useEffect, useState, useRef } from "react";
import { Card, Button, TextField, Box, palette } from "@material-ui/core";
import { useStyles } from "../../../styles/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  progressReportListAction, applicationListAction, updateApplicationAction, getApplicationAction, getProgressReportAction, updateProgressReportByObject, ConfigProgressReport, updateChalaniByObject,
  storeProgressReportAction} from "../../../redux/actions/ApplicationActions";
/* from application List */
import { LoadApplicationTemplate, ApplicationStoreAction } from '../../../redux/actions/CustomerAction';
/* end of application List */
import SimpleMenu from "../../layouts/Navigation";
import { DataGrid } from "@material-ui/data-grid";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import SearchBar from "material-ui-search-bar";
import { useHistory, Link } from "react-router-dom";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ArrowBackRounded from "@material-ui/icons/ArrowBackRounded";
import logo from "../../../logo.png";
import * as ActionTypes from "../../../redux/ActionTypes";
import PhoneInput from 'react-phone-input-2';
import Geographical from "../../../constants/Geographical.json";
import 'react-phone-input-2/lib/material.css';
import parse from 'html-react-parser';
import AuthorizationErrorComponent from '../../AuthorizationErrorComponent';
import ErrorComponent from '../../ErrorComponent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
/* from Application List */
import ApplicationTemplateEdit from "../../partials/ApplicationTemplate/ApplicationTemplateEdit";
import CustomImage from '../../ImagesComponent';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import { FaEnvelopeSquare, FaSleigh } from "react-icons/fa";
import { DropzoneArea } from "material-ui-dropzone";

import TextareaAutosize from '@material-ui/core/TextareaAutosize';

import { NepaliDatePicker } from "nepali-datepicker-reactjs"
import "nepali-datepicker-reactjs/dist/index.css"
import NepaliDate from 'nepali-date-converter'

/* end of Application List */
const defaultValues = {
  title: '',
  file: [],
  user_id:null,
  temp: ''
};

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  customButton: {
    marginTop: "15px",
    marginBottom: "30px",
    backgroundColor: "#67a8e4",
    textTransform: "Capitalize",
    clear: "both",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "30px",
    paddingRight: "30px",

    "&:hover": {
      background: "#67a8e4",
    },
  },
  searchBox: {
    '@media (max-width: 768px)': {
      marginBottom: "15px"
    },
  },
});
const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);
export default function ProgressReportListing(props) {
  const focusDiv = useRef();
  const formPointer = useRef();
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [mounted, setMounted] = useState(true);

  const applicationsListResponse = useSelector((state) => state.applicationsInfo.applicationsList);
  const [loading, setLoading] = useState(false);
  const [applicationTypes, setApplicationTypes] = useState([]);
  const [searched, setSearched] = useState("");
  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState("title");
  const [searchKeyValue, setSearchKeyValue] = useState("");
  const [applicationTypeKey, setApplicationTypeKey] = useState("all");
  const [applicationTypeKeyAssist, setApplicationTypeKeyAssist] = useState("all");
  const [restrictedStatus, setRestrictedStatus] = useState(false);
  const [restrictedResponse, setRestrictedResponse] = useState("");
  const [bodyStatus, setBodyStatus] = useState(false);
  const [applications, setApplications] = useState(false);
  const [permission, setPermission] = useState(false);
  
  const [tableConfig, setTableConnfig] = useState({
    total: 0,
    per_page: 1,
  });
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [open, setOpen] = React.useState(false);
  const [openCreate, setOpenCreate] = React.useState(false);
  const [assignOpen, setAssignOpen] = React.useState(false);
  const [editable, setEditable] = useState(false);
  const [applicationName, setApplicationName] = useState("");
  const [currentUser, setCurrentUser] = useState("");
  const [fields, setState] = useState({
    title: "",
    description: "",
    user_id: "",
    id: null,
    name:"",
    status: false,
  });
  const [btnSubmitDisabled, setBtnSubmitDisabled] = useState(false)
  const [btnStatusDisabled, setBtnStatusDisabled] = useState(false)
  /*clone from ApplicationList */
  const defaultValuesLicensePOE = {
    status: false,

  };
  const [formValuesLicensePOE, setFormValuesLicensePOE] = useState(defaultValuesLicensePOE);

  const [template, setTemplate] = useState(0);
  const [status, setStatus] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [configItem, setConfigItem] = useState(''); // for template selection
  const [hydroItem, setHydroItem] = useState(''); // for template selection
  const [dropZoneValue, setDropZoneValue] = useState([]);
  const [fileUploadErrorStatus, setFileUploadErrorStatus] = useState(false);
  const [result, setResult] = useState([]);
  const [flagger, setFlagger] = useState(true);
  const [eastError, setEastError] = useState("");
  const [eastStatus, setEastStatus] = useState(false);
  const [westError, setWestError] = useState("");
  const [westStatus, setWestStatus] = useState(false);
  const [northError, setNorthError] = useState("");
  const [northStatus, setNorthStatus] = useState(false);
  const [southError, setSouthError] = useState("");
  const [southStatus, setSouthStatus] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [deletedFiles, setDeletedFiles] = useState([]);
  const [accessRestriction, setAccessRestriction] = useState(false);
  const [applicationAccessResponse, setApplicationAccessResponse] = useState('');
  const [applicationResponse, setApplicationResponse] = useState('');
  const [applicationsRestart, setApplicationsRestart] = useState(false);
  const  [applicationListFilterByUser,setApplicationListFilterByUser] = useState([]);
  const [applicationIssuer, setApplicationIssuer] = useState([]);
  const [letterDateBS, setLetterDateBS] = useState("");
  /*end of clone from ApplicationList */
  const [filesInfo, setFilesInfo] = useState([]);
  const [formValues, setFormValues] = useState(defaultValues);
  const labelList = {
    // all: "All",
    // name: "Project Title",
    title:"Title",
    created_by_id: "Created By"
    
  };
 
  const columns = [
    { field: "id", headerName: "ID", width: 100, cellClassName: "cell_class_name" },
    { field: "title", headerName: "Progress Report Title", width: 190, cellClassName: "cell_class_name" },
    { field: 'description', headerName: "Description", width: 130, cellClassName: "cell_class_name" },
    { field: 'report_date', headerName: "Submission Date", width: 130, cellClassName: "cell_class_name" },
    { field: "report_time", headerName: "Submission Time", width: 130, cellClassName: "cell_class_name" },
    { field: "user_id", headerName: "Created By", width: 130, cellClassName: "cell_class_name" },
    { field: "actions", headerName: "Action", width: 130, cellClassName: "cell_class_name" },

  ];
  
  const handleInputChange_ = (value, name) => {
    //nepali to english date converter
    var nepaliDate = new NepaliDate(value)
    var englishDateObj = nepaliDate.getAD();
    var year = englishDateObj.year;
    var tempMonth = englishDateObj.month + 1;
    var month = parseInt(englishDateObj.month) > 9 ? tempMonth : "0" + tempMonth;
    var date = parseInt(englishDateObj.date) > 9 ? englishDateObj.date : "0" + englishDateObj.date;

    setFormValues({
      ...formValues,
      letter_date: year + "-" + month + "-" + date
    });
    setState({
      ...fields, changeStatus: true,

    })

  }
  const handleInputChangeDropzone = (e) => {
    setDropZoneValue(e)
    setState({
      ...fields, changeStatus: true,

    })
    setMounted(!mounted)
  };
  const handleInputChangeFirst = (e) => {
    const { name, value } = e.target;
    
      setFormValues({
        ...formValues,
        [name]: value,
      });
    setState({
      ...fields, changeStatus: true,
      
    })



  };
  const getDistrictName = (company) => {

   return true;
  }
  const assignUser = (event, row) => {
    setAssignOpen(true);
    setBtnSubmitDisabled(true)
    setState({
      ...fields,
      name: row.name,
      company_id: row.company.name_of_company,
      created_by_id: row.created_by_id,
      id: row.id,

      status: row.status
    });

    dispatch({ type: ActionTypes.FREE_USER_STATE, applicationsListResponse, setAssignOpen, setBtnSubmitEnabled: setBtnSubmitDisabled });


  }

  const editApplication = (event, row, editStatus) => {
    setApplicationResponse('');
    setEditFlag(true)
    setStatus(true);
    setEditable(editStatus);
    setFormValues({
      ...formValues,
      description:row.description,
      title:row.title
    }

    )
    setApplicationName(row.name);
    setState({
      ...fields,
      name: row.name,
      user_id: row.user_id,
      id: row.id,
      renderStatus: false,
      changeStatus:false,

      status: row.status
    });
    let temp_object = {
      id: row.id,
      status: row.status
    };
    //delete temp_object.status;
    dispatch(getProgressReportAction(temp_object, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setApplications, setFlagger, flagger, setResult, formValues, setFormValues, defaultValues, setFilesInfo, setOpenCreate));

    //dispatch(LoadApplicationTemplate(2, setFlagger, flagger, setResult, formValuesLicensePOE, setFormValuesLicensePOE, defaultValuesLicensePOE));
   
    //dispatch({ type: ActionTypes.FREE_USER_STATE, applicationsListResponse });


    setOpenCreate(true);
  };
  const viewFiles= (event, row, editStatus) => {
    setApplicationResponse('');
    setStatus(true);
    setEditable(editStatus);
 
    setApplicationName(row.name);
    setState({
      ...fields,
      name: row.name,
      user_id: row.user_id,
      id: row.id,
      renderStatus: false,
      changeStatus:false,


      status: row.status
    });
    let temp_object = {
      id: row.id,
      status: row.status
    };
    //delete temp_object.status;
    dispatch(getProgressReportAction(temp_object, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setApplications, setFlagger, flagger, setResult, formValues, setFormValues, defaultValues, setFilesInfo, setOpenCreate));

    //dispatch(LoadApplicationTemplate(2, setFlagger, flagger, setResult, formValuesLicensePOE, setFormValuesLicensePOE, defaultValuesLicensePOE));
   
    //dispatch({ type: ActionTypes.FREE_USER_STATE, applicationsListResponse });


    setOpenCreate(true);
  };
  const createApplication = (event) => {
    setFileUploadErrorStatus(false);
    setApplicationResponse("");
    setState({
      ...fields,
      renderStatus: false,
      changeStatus:false,
    });
    setEditable(true)
    setFormValues(defaultValues)

    setOpenCreate(true);
  };
  const deleteUser = (event, param) => {
    event.stopPropagation();
    //dispatch(CustomerDeleteAction(param.row, history));
  };
  const requestSearch = (searchedVal) => {

    applications.map((element) => (
      element.status = (element.status === null || element.status === 0) ? "Inactive" : "Active"

    ))
    applications.map((element) => (
      element = getDistrictName(element)
    ))
    setSearchKeyValue(searchedVal);
    setPage(0);
    


    dispatch(progressReportListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus,
      getDistrictName, setRows, setApplications, setTableConnfig, 0,
      page, rowsPerPage, applicationTypeKey, searchKey, searchedVal, setCurrentUser, setAccessRestriction, setPermission));
  };
  const handleSearchKey = (e) => {
    const { name, value } = e.target;
    setSearchKey(value);



  };
  const handleApplicationTypeKey = (e) => {
    const { name, value } = e.target;
    setApplicationTypeKey(value);
    setApplicationTypeKeyAssist(value);
    setPage(0);
    dispatch(progressReportListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus,
      getDistrictName, setRows, setApplications, setTableConnfig,
      0, 0, rowsPerPage, value, searchKey, searchKeyValue, setCurrentUser, setAccessRestriction, setPermission));


  };

  const handleCloseCreate = () => {
    setBtnSubmitDisabled(false)
    setOpenCreate(false);
    setCheckStatus(false);
    setEditFlag(false)
    
    setEditable(false)
    setFilesInfo([]);

    setFormValues(defaultValues);
    setDeletedFiles([]);
    setPage(0);
    setState({
      ...fields,
      fieldStatus: true, // for message display
      renderStatus: true // for refreshin the page
    });
    
  };
  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };

  /*Edit User Functionalities Section */

  const handleFieldChange = (e) => {



    setState({
      ...fields,
      changeStatus: true,

      fieldStatus: false,
      [e.target.name]: e.target.value,
    });



  };
  const handleInputChangeForCheck = (e) => {



    

    const { name, value, checked } = e.target;

    setStatus(true);
    if (!checked) {
      setCheckStatus(true);
    } else {
      setCheckStatus(false);
    }
    setFormValuesLicensePOE({
      ...formValuesLicensePOE,
      [name]: checked == true ? 1 : 0,
    });





  };

  const handleFieldChangeRadio = (e) => {
    setState({
      ...fields, changeStatus: true,
      fieldStatus: false,
      [e.target.name]: e.target.value,
    })

  }

  const handleFieldChangePhone = (value) => {

    if (fields['contact_no'] != value) {
     
      setState({
        ...fields, changeStatus: true,
        fieldStatus: false,
        'contact_no': value,
      })
    }
  }


  const updateProgressReport = (e) => {

    setBtnSubmitDisabled(true);
    e.preventDefault();
   
    let temp_object = {
      ...fields,
    };
    setStatus(true);//for error validation checker
    setApplicationResponse('')

   
    const uploadData = new FormData();
    Array.from(dropZoneValue).forEach((image_file) => {
      uploadData.append('file[]', image_file);
    });

    deletedFiles.forEach((file) => {
      uploadData.append('deletedFiles[]', parseInt(file));
    });
    uploadData.append('application_id', formValues.application_id)

    uploadData.append('issuer_id', formValues.issuer_id)
    uploadData.append('title', formValues.title)
    uploadData.append('description', formValues.description)
    uploadData.append('changeStatus', fields.changeStatus)
    uploadData.append("id", fields.id);
    
    
    dispatch(updateProgressReportByObject(uploadData, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setApplications, setApplicationResponse, history, setOpen, fields, setState, setOpenCreate, setBtnSubmitDisabled, setEditable, setEditFlag,setDeletedFiles,setDropZoneValue));



    e.target.reset();

    delete temp_object.status;
    formPointer.current?.reset();

    if (!applicationResponse.success) {
      focusDiv.current.scrollIntoView();

    }
    for (const key in uploadData) {
      delete uploadData[key];
    }
    
  };
  
  const storeProgressReport = (e) => {
    setBtnSubmitDisabled(true);
   
    e.preventDefault();
    if (dropZoneValue.length == 0) {
      setFileUploadErrorStatus(true);
      setBtnSubmitDisabled(false);
      return true;
    }
    const uploadData = new FormData();
    
    // Update the formData object
    Array.from(dropZoneValue).forEach((image_file) => {
      uploadData.append('file[]', image_file);
    });
   
    deletedFiles.forEach((file) => {
      uploadData.append('deletedFiles[]', parseInt(file));
    });

    uploadData.append('description', formValues.description)
    uploadData.append('title', formValues.title)
    uploadData.append('changeStatus', fields.changeStatus)


    


    dispatch(storeProgressReportAction(uploadData, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setApplications, setApplicationResponse, history, setOpen, fields, setState, setOpenCreate, setBtnSubmitDisabled));

    setDeletedFiles([]);
    setDropZoneValue([])
    setPage(0) // one will be added in counter 

  }
  const handleChangePage = (event, newPage) => {
    
    setPage(newPage);
    dispatch(progressReportListAction(setRestrictedResponse, setRestrictedStatus,
      setBodyStatus, getDistrictName, setRows, setApplications, setTableConnfig,
      0, newPage, rowsPerPage, applicationTypeKey, searchKey, searchKeyValue, setCurrentUser, setAccessRestriction, setPermission));
  };
  const handleChangeRowsPerPage = (event) => {
   
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    dispatch(progressReportListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus, getDistrictName, setRows, setApplications, setTableConnfig, 0, 0, event.target.value, applicationTypeKey, searchKey, searchKeyValue, setCurrentUser, setAccessRestriction, setPermission));
  };

  /*End of Edit User Functionalities Section */

  const enableEdit = (event) => {
    setEditFlag(!editFlag);
  }
  const cancelEdit = (event) => {
    setEditFlag(!editFlag);
    // setFormValuesCompany(originalCompanyData);
    // setDeletedFiles([]);
    // setDropZoneValue(defaultDropZone)
  }
  useEffect(() => {
    let abortController;
    setLoading(true)
    ConfigProgressReport(setApplicationTypes).then(res => {
      if (!res.success) {
        setAccessRestriction(true);
        setApplicationAccessResponse(res)
        setRestrictedStatus(true);
        
      }
      
      setApplicationListFilterByUser(res.application_filters);
      setApplicationIssuer(res.application_issuer)
      dispatch(progressReportListAction(setRestrictedResponse, setRestrictedStatus,
        setBodyStatus, getDistrictName, setRows, setApplications, setTableConnfig,
        0, page, rowsPerPage, applicationTypeKey, 'all', " ",
        setCurrentUser, setAccessRestriction,setPermission));
    }).finally(() => {
      setLoading(false);

    });





    return () => {

    };
  }, [fields.renderStatus == true]);

  return (
    <>
      <div className={classes.root}>
        {loading && <Grid container className={classes.bodyWrapper} style={{ position: "absolute", top: "30%", left: "50%", transform: 'translate("-50%","-50%")', fontSize: "24px" }}><span >Loading .....</span></Grid>}
        {!loading &&

          <>
        {!accessRestriction && <Grid container item xs={12}>
          <Grid item xs={12}>
            {applicationAccessResponse != "" && < ErrorComponent error={applicationAccessResponse.message} />}

          </Grid>
        </Grid>}
        {accessRestriction && restrictedStatus &&
          <> <Grid container className={classes.bodyWrapper}>
            <Grid item xs={12} style={{ height: "100vh" }}> <AuthorizationErrorComponent error={restrictedResponse.message} />

            </Grid>
          </Grid>
          </>
        }
        {restrictedStatus &&
          <> <Grid container className={classes.bodyWrapper}>
            <Grid item xs={12} style={{ height: "100vh" }}> <AuthorizationErrorComponent error={restrictedResponse.message} />

            </Grid>
          </Grid>
          </>
        }


        {!accessRestriction && !restrictedStatus && bodyStatus &&
          <Grid container className={classes.bodyWrapper}>

            <Grid item xs={2}>
              <Paper className={classes.paper}>

              </Paper>
            </Grid>

            <Grid xs={9} md={10} className={classes.rightSideContent} style={{ marginTop: "25px" }}>
              <Typography variant="h6" component="div" style={{ position: "relative", textAlign: "left", marginBottom: "15px" }} gutterBottom>
                List of Progress Report
              </Typography>
              <Grid container item xs={10} style={{ marginBottom: "10px" }}>
                <Grid item md={3} xs={12} className={classes.searchBox}>
                  <SearchBar
                    value={searched || ""}
                    onChange={(searchVal) => requestSearch(searchVal)}
                    onCancelSearch={() => cancelSearch()}
                  />
                </Grid>
                  <Grid item md={3} xs={12}>
                    <FormControl variant="outlined" className={[classes.formControl, classes.fullWidthMobile]}>

                    <InputLabel>Search Field</InputLabel>
                    <Select
                      name="search_key"
                      label={"Search Type"}
                      value={searchKey}
                      onChange={handleSearchKey}

                    >

                      {Object.keys(labelList).map((key) => (
                        <MenuItem key={key} value={key}>
                          {labelList[key]}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {/* <Grid item xs={3}>
                  <FormControl variant="outlined" className={classes.formControl}>

                    <InputLabel>Application Type</InputLabel>
                    <Select
                      name="search_application_type"
                      label={"Search Type"}
                      value={applicationTypeKey}
                      onChange={handleApplicationTypeKey}

                    > <MenuItem key="all" value="all" xyz="all">
                        All
                      </MenuItem>

                      {applicationTypes.map((item) => {

                        return <MenuItem key={item.id} value={item.id} xyz={item.name}>
                          {item.name}
                        </MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Grid> */}
                  {permission && <Grid item md={3} xs={6} >
                  <Button

                    autoFocus onClick={(event) => {
                      createApplication(event);
                    }} className={[classes.customButton, classes.addButton].join(" ")}
                    orientation="vertical"
                    aria-label="vertical contained button group"
                    variant="contained"
                    color="primary"
                    style={{ clear: "both" }}
                  >Add Progress Report</Button>
                </Grid>
                 }

              </Grid>
              <Grid container item xs={10}>
                <Grid xs={12}>
                  <div className={classes.MuiDataGrid_windowContainer}>

                    {applications.length !== 0 ? (
                      <>
                        <TableContainer className={classes.container}>
                          <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                              <TableRow>
                                {columns.map((column) => {
                                  if (column.field.localeCompare("actions")) {
                                    return (<TableCell
                                      key={column.id}
                                      align={column.align}
                                      style={{ minWidth: column.minWidth }}
                                    >
                                      {column.headerName}
                                    </TableCell>)

                                    
                                  } else {
                                    let temp = permission == true ? (<TableCell
                                      key={column.id}
                                      align={column.align}
                                      style={{ minWidth: column.minWidth }}
                                    >
                                      {column.headerName}
                                    </TableCell>) : "";
                                    return temp;
                                  }
                                })
                                }

                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {rows.map((row, index) => {
                                return (
                                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                    {columns.map((column) => {
                                      const value = row[column.field];
                                      if (column.field =="title") {
                                        return (<TableCell key={column.field}>
                                          <div
                                            style={{
                                              textAlign: "center",
                                              paddingLeft: "15px",
                                              paddingRight: "15px",
                                            }}
                                            key={column.field}
                                          >  {column.field != "status" && value} <br/><br/>
                                            {(row['status'] != "draft" && row['status'] != "intermediate") &&
                                              <span><Button variant="outlined" size="large" color="success" style={{ backgroundColor: "#569919", color: "#fff", fontSize: "10px", marginBottom: "5px",marginTop:"10px"}} onClick={(event) => {
                                                viewFiles(event, row, false);
                                              }}> Documents</Button> <br /></span>}
                                                                

                                             </div>

                                        </TableCell>)
                                      } else if (column.field == "actions"){

                                        return permission == true ?(<TableCell key={column.field}>
                                          <div
                                            style={{
                                              textAlign: "center",
                                              paddingLeft: "15px",
                                              paddingRight: "15px",
                                            }}
                                            key={column.field}
                                          >
                                            {(row['status'] != "draft" && row['status'] != "intermediate") &&
                                              <span><Button variant="outlined" size="large" color="success" style={{ backgroundColor: "#569919", color: "#fff", fontSize: "10px", marginBottom: "5px" }} onClick={(event) => {
                                                editApplication(event, row, true);
                                              }}> Edit</Button> <br /></span>}


                                          </div>

                                        </TableCell>):""
                                      }else{
                                        return (
                                          <TableCell key={column.field} >
                                            {row['status'] == "cancelled" && column.field == "status" && <span style={{ color: "red" }}>
                                              <Button variant="outlined" size="small" style={{ backgroundColor: "rgb(185 32 52)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                Cancelled
                                              </Button>
                                            </span>}
                                            {row['status'] == "draft" && column.field == "status"
                                              &&
                                              <span style={{ fontSize: "bold", color: "#000", fontSize: "14x" }}>
                                                <Button variant="outlined" size="small" style={{ backgroundColor: "rgb(74 24 0)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                  Draft</Button></span>
                                            }
                                            {row['status'] == "pending" && column.field == "status"
                                              &&

                                              <span style={{ fontSize: "bold", color: "#234206", fontSize: "14px" }}><Button variant="outlined" size="small" style={{ backgroundColor: "rgb(16 100 159)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                Pending</Button></span>
                                            }
                                            {row['status'] == "processing" && column.field == "status" &&
                                              <span style={{ fontSize: "bold", color: "#3f51b5", fontSize: "14px" }}>  <Button variant="outlined" size="small" style={{ backgroundColor: "rgb(126 83 159)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                In progress</Button></span>
                                            }
                                            {row['status'] == "completed" && column.field == "status" &&
                                              <span style={{ fontSize: "bold", color: "#000", fontSize: "14px" }}>
                                                <Button variant="outlined" size="small" style={{ backgroundColor: "rgb(78 143 20)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                  Completed</Button></span>
                                            }
                                            {row['status'] == "intermediate" && column.field == "status" &&
                                              <span style={{ fontSize: "bold", color: "#000", fontSize: "14px" }}>
                                                <Button variant="outlined" size="small" style={{ backgroundColor: "rgb(153 167 38)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                  Intermediate</Button></span>
                                            }
                                            {column.field != "status" && value}

                                          </TableCell>
                                        );
                                      }
                                    })}
                                    {



                                    }

                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        <TablePagination
                          rowsPerPageOptions={[2, 10, 25, 100]}
                          component="div"
                          count={tableConfig.total}
                          rowsPerPage={tableConfig.per_page}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      </>
                    ) : (
                      <div className={classes.beforeLoad}>


                        <span>Displaying Progress List...</span>
                        <br />
                        {applicationsListResponse.hasOwnProperty('extra') && applicationsListResponse.success &&
                          applicationsListResponse.message


                        }
                      </div>
                    )}
                  </div>
                </Grid>
              </Grid>
              <Grid>
                
               {/* Add Chalani */}
                <Dialog
                  onClose={handleCloseCreate}
                  aria-labelledby="customized-dialog-title"
                  open={openCreate}
                  fullWidth
                  maxWidth="lg"
                >
                  {editable &&   <DialogTitle id="customized-dialog-title" onClose={handleCloseCreate}>
                    <b
                      className={classes.primary}
                      style={{ textAlign: "center" }}
                    >
                      Add Progress Report
                    </b>
                   
                  </DialogTitle>
                  }
                  {!editable && <DialogTitle id="customized-dialog-title" onClose={handleCloseCreate}>
                    <b
                      className={classes.primary}
                      style={{ textAlign: "center" }}
                    >
                      View Progress Report Files
                    </b>

                  </DialogTitle>
                  }


                  <DialogContent dividers>


                    {!accessRestriction && <Grid container item xs={12} >
                      <Grid item xs={12} ref={focusDiv}>
                        {applicationResponse != "" && applicationResponse.success == false && < ErrorComponent error={applicationResponse.message} />}

                      </Grid>
                    </Grid>}
                    <form ref={formPointer} onSubmit={editFlag==true?updateProgressReport:storeProgressReport} >
                      {editable &&   <Grid container item xs={12}>
                       
                          <Grid item xs={12} sm={4}>
                            <FormControl variant="outlined" className={[classes.formControl, classes.verticalGap]}>
                              <TextField
                                id="title"
                                name="title"
                                margin="normal"
                                type="text"
                                variant="outlined"
                                label="Progress Report Title"
                                value={formValues.title}
                                onChange={handleInputChangeFirst}
                                inputlabelprops={{
                                  shrink: true,
                                }}
                                required
                              />
                            </FormControl>

                          </Grid>
                        <br></br>
                    </Grid>
                     }
                      {editable &&   <Grid container item xs={12}>
                      
                      <Grid item xs={12} sm={12} style={{marginTop:"20px"}}>
                      
                      <InputLabel style={{ marginBottom: "10px" }}>Progress Report Description</InputLabel>
                      <FormControl variant="outlined" className={classes.formControl}>

                        <TextareaAutosize
                          id="description-input"
                          name="description"
                          label="Description"
                          aria-label="minimum height"
                          minRows={4}
                          placeholder="Write down short description on Progress Report."
                          value={formValues.description}
                          onChange={handleInputChangeFirst}
                          required
                          inputlabelprops={{
                            shrink: true,
                          }}
                          style={{ width: "100%" }}
                              />

                            </FormControl>
                      </Grid>
                      
                        
                        
                      </Grid>
                       }
                      <Grid
                        item
                        xs={12} container
                        style={{
                          marginTop: "15px",
                          padding: "25px",
                          border: "1px solid #ddd",
                        }}
                      >

                        
                        {!editable && formValues.file.length != 0 &&
                            formValues.file.map((option, index) => (

                              (deletedFiles.length && deletedFiles.includes(option)) ?
                                false
                                :
                                <CustomImage option={option} index={index} deletedFiles={deletedFiles}
                                  setDeletedFiles={setDeletedFiles} key={index} editFlag={editFlag} filesInfo={filesInfo} />

                            ))
                          }
                        {!editable && formValues.file.length == 0 &&
                          <span>Any file has not been uploaded.</span>
                        }
                        
                        {editable &&  
                        <>
                         <Typography
                          variant="subtitle1"
                          component="div"
                          gutterBottom
                          style={{ fontWeight: "bold", width: '100%' }}
                        >
                          Progress Report File
                        </Typography>
                        <Typography
                          variant="caption"
                          display="block"
                          style={{ marginBottom: "10px" }}
                          gutterBottom
                        >
                          You can upload multiple files here
                        </Typography>
                      
                        {formValues.file.length != 0 && <Grid
                          item
                          xs={12} container
                          style={{
                            marginTop: "15px",
                            marginBottom: "15px",
                            padding: "25px",
                            border: "1px solid #ddd",
                          }}
                        >
                          {formValues.file.length != 0 &&
                            formValues.file.map((option, index) => (

                              (deletedFiles.length && deletedFiles.includes(option)) ?
                                false
                                :  
                                <CustomImage option={option} index={index} deletedFiles={deletedFiles}
                                  setDeletedFiles={setDeletedFiles} key={index} editFlag={editFlag} filesInfo={filesInfo} setState={setState} fields={fields}/>

                            ))
                          }
                        </Grid>
                         }
                       

                    <DropzoneArea
                        acceptedFiles={[
                          "image/*",
                          "application/pdf",
                          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

                        ]}
                        name="file"
                        id="file"
                        filesLimit={5}
                        dropzoneText="Drop files here or click to upload."
                        onChange={handleInputChangeDropzone}
                       
                        showPreviews={true}
                        showPreviewsInDropzone={false}
                        useChipsForPreview
                        previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                        previewChipProps={{ classes: { root: classes.previewChip } }}
                        previewText="Selected files"
                        maxFileSize={204800000000}
                        multiple
                        dropzoneParagraphClass={classes.dropzoneParagraphClass}

                      /> 
                            {fileUploadErrorStatus && dropZoneValue.length == 0 && <span style={{ color: "red" }}>You forgot to submit the Progress Report File.</span>}
                      </>
                     }
                      </Grid>
                      {editable &&  
                        <DialogActions>
                          <Button autoFocus type="submit" 
                            orientation="vertical"
                            aria-label="vertical contained button group"
                            variant="contained"
                            color="primary"
                            className={classes.customButton}
                            style={{ clear: "both" }}
                            disabled={btnSubmitDisabled}
                            >
                            Submit
                          </Button>
                        </DialogActions>
                      }
                    
                    </form>
                  </DialogContent>

                </Dialog>


              </Grid>
            </Grid>
          </Grid>
        }
        </>
        }
      </div>
    </>
  );
}
